<template>
  <div>
    <v-speed-dial
        v-model="fab"
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition">
      <template v-slot:activator>
        <v-btn v-model="fab" fab icon x-small>
          <v-icon v-if="fab" color="pink darken-1 icon-xl-2x">mdi-close</v-icon>
          <v-icon v-else class="icon-xl-2x" color="black">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-tooltip v-if="can('userActivity_access')" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-status="'userActivity_access'"
                 class="ml-1 "
                 color="purple"
                 dark
                 fab
                 outlined
                 v-bind="attrs"
                 x-small
                 @click="action(data, 'userActivity')"
                 v-on="on">
            <v-icon dark>mdi-domain</v-icon>
          </v-btn>
        </template>
        <span>ویرایش وضعیت فعالیت</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-status="'user_edit'"
                 class="ml-1 btn-edit rounded-pill pdd"
                 fab
                 outlined
                 tool
                 v-bind="attrs"
                 x-small
                 @click="action(data, 'edit')"
                 v-on="on">
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>ویرایش مشخصات کاربر و تغییر نقش</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-status="data.id == 1 ? 'adminInfo_access' : 'user_show'"
                 class="ml-1 btn-show rounded-pill pdd"
                 fab
                 outlined
                 v-bind="attrs"
                 x-small
                 @click="action(data, 'information')"
                 v-on="on">
            <v-icon dark>mdi-information</v-icon>
          </v-btn>
        </template>
        <span>مشاهده اطلاعات کاربر حقیقی یا حقوقی</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-status="'adminUsersbtn_history'"
                 class="ml-1 btn-history rounded-pill pdd"
                 fab
                 outlined
                 v-bind="attrs"
                 x-small
                 @click="action(data, 'history')"
                 v-on="on">
            <v-icon dark>mdi-history</v-icon>
          </v-btn>
        </template>
        <span>تاریخچه کاربر</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-status="'adminWallet_access'"
                 class="ml-1 btn-charge-wallet rounded-pill pdd"
                 fab
                 outlined
                 v-bind="attrs"
                 x-small
                 @click="action(data, 'wallett')"
                 v-on="on">
            <v-icon dark>mdi-wallet</v-icon>
          </v-btn>
        </template>
        <span>کیف پول کاربری</span>
      </v-tooltip>


      <!--      <v-tooltip top>-->
      <!--        <template v-slot:activator="{ on, attrs }">-->
      <!--          <v-btn v-status="'adminWallet_access'"-->
      <!--                 class="ml-1 btn-charge-wallet rounded-pill pdd"-->
      <!--                 fab-->
      <!--                 outlined-->
      <!--                 v-bind="attrs"-->
      <!--                 x-small-->
      <!--                 @click="action(data, 'walletShow')"-->
      <!--                 v-on="on">-->
      <!--            <v-icon dark>mdi-wallet-membership</v-icon>-->
      <!--          </v-btn>-->
      <!--        </template>-->
      <!--        <span>مشاهده کیف پول کاربران</span>-->
      <!--      </v-tooltip>-->

      <v-tooltip top>
        <!--          v-status="data.pack.id == '1' ?'accountSwitch_access_user' : 'accountSwitch_access'"-->
        <!--          accountSwitch_access_user-->
        <!--          v-if="data.pack.id==1 || data.pack.id == 3?can('accountSwitch_access_user'):can('accountSwitch_access')"-->
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-if="data.pack.id==1 || data.pack.id == 3 || data.pack.id == 23 ? can('accountSwitch_access_user') : can('accountSwitch_access')"
              class="ml-1 btn-management rounded-pill pdd" fab outlined v-bind="attrs" x-small
              @click="action(data, 'checkout')" v-on="on">
            <v-icon dark>mdi-login</v-icon>
          </v-btn>
        </template>
        <span>ورود به حساب کاربر</span>
      </v-tooltip>
    </v-speed-dial>
  </div>
</template>

<script>
import {can} from "@/core/plugins/acl";

export default {
  methods: {can},

  props: {
    data: {},
    action: Function,
    meta: Object
  },

  data() {
    return {
      USER_ROLE_LEVEL: process.env.VUE_APP_USER_ROLE_LEVEL,
      classBtn: 'btn btn-sm text-center ',
      iconClass: 'px-1 text-center icon-md fa fa-',
      direction: 'right',
      color: {
        'edit': 'warning',
        'delete': 'error',
        'show': 'info',
        "refresh": 'indigo',
      },
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-x-reverse-transition',
    }
  }
}
</script>

<style scoped>
.v-speed-dial >>> .pdd {
  padding: 8px !important;
}
</style>
